"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Filter = void 0;
var Filter = /** @class */ (function () {
    function Filter(filter) {
        this.order = filter.order;
        this.name = filter.name;
        this.value = filter.value;
        this.isSelected = filter.isSelected;
        this.dateFilterType = filter.dateFilterType;
    }
    return Filter;
}());
exports.Filter = Filter;
//# sourceMappingURL=Filter.js.map